import React, { Component } from 'react'
import Icon from './Icon'
import Logo from './Logo'

interface Props {
  onSidebarOpen: () => void
  onLogoClick?: () => void
}

export default class MobileHeader extends Component<Props> {
  render () {
    return (
      <div className="px-4 py-1 flex items-center justify-between bg-primary sm:hidden">
        <Logo type="regular" onClick={this.props.onLogoClick} />
        <Icon
          name="menu"
          size="medium"
          color="white"
          onClick={this.props.onSidebarOpen} />
      </div>
    )
  }
}
